<span *ngIf="protocolType; else noType"
      class="protocol-type-badge"
      [nbTooltip]="protocolType.name"
      nbTooltipPlacement="top">
  <span class="protocol-type-badge__dot" [style.background]="protocolType.color"></span>
  <span class="protocol-type-badge__shortcut">{{ protocolType.shortcut }}</span>
  <span class="protocol-type-badge__sep">·</span>
  <span class="protocol-type-badge__name">{{ protocolType.name }}</span>
</span>

<ng-template #noType>
  <span class="text-hint">—</span>
</ng-template>
